
<div class="card">
    <div class="card-header">
        <h4>Edit Product Subcategory</h4>
    </div>
    <form #subcategoryEdit="ngForm" (ngSubmit)="editProductSubcategory(subcategoryEdit.value)" [formGroup]="editSubcategoryForm">
    <div class="row">
      <div class="col-sm-6 mb-3 mb-sm-0">
        <div class="card border-0 shadow-none text-center">
          <div class="card-body ">
              <img [src]="selectedFile"  width="150" height="150" class="rounded-circle mb-3" alt="category Image">
              <br>
              <div class="custom-file" *ngIf="permissions.includes('Edit')">
                <div class="file btn btn-lg bg-primary">
              Upload &nbsp;<i class="fa fa-upload"></i>
              <input type="file" [ngClass]="{'is-invalid':submitted && editSubcategoryForm.controls.subCategoryImage.errors}" accept="image/*" (change)="setSubcategoryProfile($event)">
              </div>
              </div>
              <div class="invalid-feedback mt-2" style="display: block;" id="fileNameDisplay"
                          *ngIf="submitted && editSubcategoryForm.controls.subCategoryImage.errors">
                          <div *ngIf="editSubcategoryForm.controls.subCategoryImage.errors?.required">
                              Icon is required.
                          </div>
                      </div>
                  
              <a href="javascript:void(0)" *ngIf="editSubcategoryForm.get('subCategoryImage')?.valid && permissions.includes('Edit')" (click)="removeFile()"
                          class="position-absolute" style="top: 10px; right: 180px; color: #dc3545;">
                          <i class="fa fa-times-circle fa-lg"></i>
              </a>
              <p style="font-size: 13px; margin-top: 4px;">PNG/JPG with max size 50 KB allowed.</p>
          </div>
        </div>
      </div>
        <div class="col-sm-6">
          <div class="card border-0 shadow-none text-center">
            <div class="card-body">
                <br>
                <br>
                <p class="card-text">Here's how it will look on Mobile App </p>
                <br>
                <img src="assets\images\app-productSubcategory.png" width="300" height="80" class=" mb-3" alt="...">
              
            </div>
          </div>
        </div>
    </div>
    <hr >
    <div class="row">
      <div class="col-lg-12">
        <div class="card border-0 shadow-none text-center">
          <div class="card-body">
            <div class="row d-flex">
                <div class="form-group col-md-3 ">
                    <label class="col-form-label">Subcategory Name <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" class="form-control" autocomplete="off" id="subCategoryName" [readOnly]="!permissions.includes('Edit')" placeholder="Enter Subcategory Name" formControlName="subCategoryName" required  [ngClass]="{'is-invalid':submitted && editSubcategoryForm.controls.subCategoryName.errors}" (keypress)="onSubcategoryNameKeyPress($event)" ngModel >
                    <div class="invalid-feedback">
                        <div >
                            Subcategory Name is required.
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-3">
                    <label class="col-form-label">Subcategory Description <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" class="form-control" autocomplete="off" id="subCategoryDesc" [readOnly]="!permissions.includes('Edit')" placeholder="Enter Subcategory Description" formControlName="subCategoryDesc" required  [ngClass]="{'is-invalid':submitted && editSubcategoryForm.controls.subCategoryDesc.errors}" (keypress)="onSubcategoryDescKeyPress($event)" ngModel >
                    <div class="invalid-feedback">
                        <div>
                            Subcategory Description is required.
                        </div>
                    </div>
                </div>

                <!-- <div class="form-group col-md-3 ">
                  <label class="col-form-label">Category <span aria-hidden="true"
                          class="symbol required" style="color:red;">*</span>
                  </label>
                  <ng-select formControlName="category" id="category"  name="category" placeholder="Select Category" required  [ngClass]="{'is-invalid':submitted && editSubcategoryForm.controls.category.errors}" >
                      <ng-option *ngFor="let categoryList of categoryDropdownList; let i = index" [value]="categoryDropdownList[i].id">{{categoryDropdownList[i].name}}</ng-option>
                      
                    </ng-select>
                  <div class="invalid-feedback">
                      <div >
                        Category is required.
                      </div>
                  </div>
              </div> -->
              <div class="form-group col-md-3">
                <label class="col-form-label">Category <span aria-hidden="true"
                    class="symbol required" style="color:red;">*</span></label>
                <input type="text" id="productName" readonly value="{{this.editSubcategoryForm.value.category}}" class="form-control">
              </div>
                
            </div>
            <div class="row d-flex">
              <div class="form-group col-md-3" *ngIf="!permissions.includes('Approve')">
                <label class="col-form-label">Status <span aria-hidden="true"
                    class="symbol required" style="color:red;">*</span></label>
                <input type="text" id="productName" readonly value="{{this.editSubcategoryForm.value.status | titlecase}}" class="form-control">
              </div>
              
                <div class="form-group col-md-3 " *ngIf="permissions.includes('Approve')">
                    <label class="col-form-label">Status <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select formControlName="status" (change)="subCategoryStatusChange($event)" id="status" name="status" placeholder="Select Status" required  [ngClass]="{'is-invalid':submitted && editSubcategoryForm.controls.status.errors}" >
                        <ng-option value="ACTIVE">Active</ng-option>
                        <ng-option value="INACTIVE">Inactive</ng-option>
                      </ng-select>
                    <div class="invalid-feedback">
                        <div >
                            Status is required.
                        </div>
                    </div>
                </div>
            </div>
            <div class="row d-flex">
                <div class="form-group col-md-12 text-right">
                    <button class="btn btn-primary" *ngIf="permissions.includes('Edit')" type="submit">Update</button>
                    <button class="btn btn-primary" *ngIf="permissions.includes('Approve')" (click)="statusUpdate()" type="button">Update</button>
                    <button class="btn btn-secondary" id="cancelButton" (click)="cancelButton()">Cancel</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
  </form>  
</div>

<app-modal #editProductSubcategoryModalOpen [modalConfig]="modalProductSubcategory" style="width: 1200px;">
   
<br>
<h4 class="text-center">Are you sure ?</h4>
<br>
<p class="text-center">This action will change the status of associated <strong>ACTIVE </strong> Products</p>
<hr class="new5">
<div class="row">
    <div class="col-sm-3 mb-2 text-center" *ngFor="let product of productMappedList">
        <div class="card text-center border-light cardStyle" style="width: 10rem; height: 8rem;">
            <div class="card-body">
                <br>
              <h5 class="card-title">{{product}}</h5>
            </div>
          </div>
    </div>
</div>

<br>
<div class="row d-flex">
    <div class="form-group col-md-12 text-center">
        <button class="btn btn-primary" (click)="confirmModal()">Confirm</button>
        <button class="btn btn-secondary" id="cancelButton" (click)="closeModalBlocked($event)">Cancel</button>
    </div>
</div>
  
</app-modal> 